import { render, staticRenderFns } from "./InputDefault.vue?vue&type=template&id=e2ec23ba&scoped=true&"
import script from "./InputDefault.vue?vue&type=script&lang=js&"
export * from "./InputDefault.vue?vue&type=script&lang=js&"
import style0 from "./InputDefault.vue?vue&type=style&index=0&id=e2ec23ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ec23ba",
  null
  
)

export default component.exports